<!-- Parsec Cloud (https://parsec.cloud) Copyright (c) AGPL-3.0-only 2016-present Scille SAS -->

<template>
  <ion-list class="list list-container invitations-list-container">
    <ion-list-header
      class="invitations-list-header list-header"
      lines="full"
      v-if="isLargeDisplay"
    >
      <ion-text class="list-header-label cell-title label-email">
        {{ $msTranslate('InvitationsPage.emailInvitation.listDisplayTitles.email') }}
      </ion-text>
      <ion-text class="list-header-label cell-title label-sentOn">
        {{ $msTranslate('InvitationsPage.emailInvitation.listDisplayTitles.sentOn') }}
      </ion-text>
      <ion-text
        v-if="windowWidth > WindowSizeBreakpoints.XL"
        class="list-header-label cell-title label-sentBy"
      >
        {{ $msTranslate('InvitationsPage.emailInvitation.listDisplayTitles.sentBy') }}
      </ion-text>
      <ion-text class="list-header-label list-item-end cell-title label-space" />
    </ion-list-header>
    <invitation-item
      v-for="invitation in invitations"
      class="request"
      :key="invitation.token"
      :invitation="invitation"
      @greet-click="$emit('greetClick', invitation)"
      @copy-link-click="$emit('copyLinkClick', invitation)"
      @send-email-click="$emit('sendEmailClick', invitation)"
      @delete-click="$emit('deleteClick', invitation)"
    />
  </ion-list>
</template>

<script setup lang="ts">
import InvitationItem from '@/components/invitations/InvitationItem.vue';
import { UserInvitation } from '@/parsec';
import { IonList, IonListHeader, IonText } from '@ionic/vue';
import { useWindowSize, WindowSizeBreakpoints } from 'megashark-lib';

defineProps<{
  invitations: Array<UserInvitation>;
}>();

const { isLargeDisplay, windowWidth } = useWindowSize();

defineEmits<{
  (e: 'greetClick', invitation: UserInvitation): void;
  (e: 'copyLinkClick', invitation: UserInvitation): void;
  (e: 'sendEmailClick', invitation: UserInvitation): void;
  (e: 'deleteClick', invitation: UserInvitation): void;
}>();
</script>

<style scoped lang="scss"></style>
